import { IAppState } from '../../redux';

export const selectAuctionPoints = (state: IAppState): number | null => {
  return state.user.auctionPoints?.balance || null;
};
